<div class="pr">
  <div class="pr-table-panel block" style="width: 100%">
    <div class="pr-column-box">
      <div class="pr-column" style="margin-right: 0; min-width: 100px; width: 25%">
        <div class="pr-row-box">
          <div class="pr-row middle" style="max-height: 30px">
            <div class="pr-banner">Current</div>
          </div>
          <div class="pr-row white-background">
            <div class="content">
              <div class="block bold">Group by: {{data.envGlobalSettingsDTO.securityCustAttrAbbr}}</div>
              <div class="middle" style="width: 250px;">
                <p-chart type="doughnut" [data]="chartDataCustCatBefore" [options]="options" width="250px"
                         height="250px"></p-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pr-column" style="margin-right: 0; width: 50%">
        <div class="pr-row-box">
          <div class="pr-row white-background" style="margin-top: 30px;">
            <div class="block">&nbsp;</div>
            <div class="pr-table">
              <mat-table matSort data-allocation-table [dataSource]="tableDataSource"
                         matSortActive="group" matSortDirection="asc">
                <ng-container cdkColumnDef="color">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell data-color *matCellDef="let row">
                    <div class="key" [style.backgroundColor]="row.color"></div>
                  </mat-cell>
                </ng-container>

                <ng-container cdkColumnDef="beforeTotal">
                  <mat-header-cell *matHeaderCellDef data-before-total-sort mat-sort-header>Current</mat-header-cell>
                  <mat-cell data-before-total *matCellDef="let row"
                            [innerText]="(row.beforeTotal | number: '1.1-1') + '%'"></mat-cell>
                </ng-container>

                <ng-container cdkColumnDef="group">
                  <mat-header-cell *matHeaderCellDef data-group-sort mat-sort-header>
                    {{data.envGlobalSettingsDTO.securityCustAttrAbbr}}
                  </mat-header-cell>
                  <mat-cell data-group *matCellDef="let row" [innerText]="row.group"></mat-cell>
                </ng-container>

                <ng-container cdkColumnDef="afterTotal">
                  <mat-header-cell *matHeaderCellDef data-after-total-sort mat-sort-header>After Adjustments
                  </mat-header-cell>
                  <mat-cell data-after-total *matCellDef="let row"
                            [innerText]="(row.afterTotal | number: '1.1-1') + '%'"></mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></mat-header-row>
                <mat-row data-allocation-table-row *matRowDef="let row; columns: tableColumns"></mat-row>
              </mat-table>
            </div>
          </div>
        </div>
      </div>

      <div class="pr-column" style="min-width: 100px; width: 25%">
        <div class="pr-row-box">
          <div class="pr-row middle" style="max-height: 30px">
            <div class="pr-banner">After Adjustments</div>
          </div>
          <div class="pr-row white-background">
            <div class="content">
              <div class="block">&nbsp;</div>
              <div class="middle" style="width: 250px;">
                <p-chart type="doughnut" [data]="chartDataCustCatAfter" [options]="options" width="250px"
                         height="250px"></p-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="note right">Note: Totals may not add to 100% due to rounding.</div>
</div>
